function _(n,t,e){var o=n(29),r={object:!0,function:!0,undefined:!0};t.exports=function(n){return!!o(n)&&hasOwnProperty.call(r,typeof n)}}
//# sourceMappingURL=is.min.js.map